import React from "react";
import {Button, Form} from "react-bootstrap";
import PropTypes, {InferProps} from "prop-types";
import {SecondaryAuthorizationData} from "./api";
import {useTranslation} from "react-i18next";

export default function SuccessRegistration({
    secondaryAuthorizationData,
    customerName
                                            }: InferProps<typeof SuccessRegistration.propTypes>){
    let secondaryAuthorization : SecondaryAuthorizationData = secondaryAuthorizationData;

    const {t} = useTranslation();

    const renderSecondaryId = () =>{
        let email = secondaryAuthorization.secondaryIdentifier.email;

        if(email !== ""){
            return t("secondaryAuth.email") + ": " + email;
        }

        return t("secondaryAuth.phoneNumber") + ": " + secondaryAuthorization.secondaryIdentifier.phoneNumber;
    };

    return (
        <div>
            <div className="container">
                <p className={"header"}>{t("successForm.header")}</p>
                <p className={"description"}>{t("successForm.description")}</p>
                <p>
                {t("successForm.customerId") + customerName} <br />
                {t("successForm.accountNumber") + secondaryAuthorization.account.accountNumber} {secondaryAuthorization.account.currency !== "" && secondaryAuthorization.account.currency}<br />
                {renderSecondaryId()} <br />
                {t("successForm.dueDate") + secondaryAuthorization.dueDate}<br />
                {t("successForm.thanks")}<br />
                CIB Bank
                </p>
            </div>
            <Form>
                <Button type={"submit"}>
                    {t("successForm.newSecondaryAuthorization")}
                </Button>
            </Form>
        </div>
    );
}

SuccessRegistration.propTypes = {
    secondaryAuthorizationData: PropTypes.any.isRequired,
    customerName: PropTypes.string.isRequired
};